import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function storeTransportDocument(shippingCodeId) {
  const axios = axiosInstance().primoLab;
  let data = [];

  await axios
    .post("/shipping-codes/store-transport-document", {
      id: shippingCodeId,
    })
    .then(async (response) => {
      data = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { data };
}
